import React, { Component } from 'react';

import AccesoSimultaneo from "./AccesoSimultaneo";
import ConfiguracionContrasenia from "./ConfiguracionContrasenia";

const ModoPersonalizado = (props) => {
    return (
        <div className="">
            <div>
                <AccesoSimultaneo plataformas={props.plataformas}
                    plataformaValueChange={props.plataformaValueChange} />
                <ConfiguracionContrasenia alfabetica={props.alfabetica}
                    caracteresEspeciales={props.caracteresEspeciales}
                    caracteresMinimos={props.caracteresMinimos}
                    caseSensitive={props.caseSensitive}
                    numerica={props.numerica}
                    permiteCaracteresIguales={props.permiteCaracteresIguales}
                    permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                    permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                    permiteRepetirPosicion={props.permiteRepetirPosicion}
                    checkboxChangeState={props.checkboxChangeState}
                    textChangeState={props.textChangeState}
                    radioButtonChangeContrasenia={props.radioButtonChangeContrasenia}/>
            </div>
        </div>
    );
};

export default ModoPersonalizado;

